import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import styles from "./TabSelector.module.scss";
export const TabSelector = ({ active = false, onClick, children, size = "large", disabled = false, className, }) => {
    return (_jsx("button", { className: classNames(styles.tabSelector, styles[size], { [styles.active]: active, [styles.disabled]: disabled }, className), onClick: onClick, disabled: disabled, type: "button", children: children }));
};
//# sourceMappingURL=TabSelector.js.map